// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__v053C","options":"tab_options__4VOrF","item":"tab_item__RP5JC","active":"tab_active__p8rSQ"};